module.exports = __webpack_public_path__ + "img/user.388dcff8.png";